import React from 'react'
import { AppContent, AppSidebar, AppHeader, AppFooter } from '../components/index'

const DefaultLayout = () => {
  return (
    <div className="wrapper d-flex flex-column min-vh-100">
      <AppHeader />
      <div className="d-flex flex-row flex-grow-1">
        <AppSidebar />
        <div className="d-flex flex-column flex-grow-1 main-content-wrapper">
          <div className="container-background">
            <AppContent />
          </div>
        </div>
      </div>
      <AppFooter />
    </div>
  )
}

export default DefaultLayout
